module.exports = __webpack_public_path__ + "img/health1.5ea34dd0.png";